export const APPSTORE_URL = 'https://apps.apple.com/app/id1470977406';
export const PLAYSTORE_URL =
  'http://play.google.com/store/apps/details?id=eu.feedbackloop.app';

export default process.env.REACT_APP_HOST;
